import ModalBasketOutOfStock from 'Modals/ModalBasketOutOfStock';

export default {
    default: {
      component: ModalBasketOutOfStock,
      text: 'Un produit présent dans votre commande est victime de son succès et n\'est plus disponible pour le jour de livraison choisi.',
    },
};
